import { Button, Checkbox, Modal } from "@xola/ui-kit";
import React, { useState } from "react";
import { SecondaryButton } from "../Common/SecondaryButton";

interface ConversionTrackingTermsModalProps {
    isOpen: boolean;
    onClose: (isAccepted: boolean) => void;
}

export const ConversionTrackingTermsModal = ({ isOpen, onClose }: ConversionTrackingTermsModalProps) => {
    return (
        <Modal isOpen={isOpen} size="large" onClose={onClose}>
            <ModalContent onClose={onClose} />
        </Modal>
    );
};

const ModalContent = ({ onClose }: Pick<ConversionTrackingTermsModalProps, "onClose">) => {
    const [isAccepted, setIsAccepted] = useState(false);

    return (
        <>
            <Modal.Header>Terms of Use</Modal.Header>

            <Modal.Body className="space-y-4">
                <h3>Third Party Services; Links to Other Web Sites</h3>

                <p>
                    The Digital Properties may include or interoperate with applications, services, features or
                    functionalities provided by third parties. In connection with such third party applications,
                    services, features or functionalities, you may send (or such third parties may get access to)
                    certain information about or related to you or your activities with such third party applications or
                    services. The collection, use, storage and disclosure of such information by these third parties is
                    subject to their own privacy policies and we have no responsibility or liability therefor. Our
                    Digital Properties may include links to other web sites whose privacy practices may differ from
                    those of Xola. If you submit personal information to any of those sites, your information is
                    governed by the privacy policy or statements governing that particular site. We encourage you to
                    carefully read the privacy statement of any web site you visit.
                </p>

                <Checkbox
                    label="I accept these terms and conditions"
                    checked={isAccepted}
                    onChange={(e: any) => {
                        setIsAccepted(e.target.checked);
                    }}
                />
            </Modal.Body>

            <Modal.Footer>
                <SecondaryButton
                    onClick={() => {
                        onClose(false);
                    }}
                >
                    Cancel
                </SecondaryButton>

                <Button
                    disabled={!isAccepted}
                    type="button"
                    color="primary"
                    onClick={() => {
                        onClose(true);
                    }}
                >
                    Continue
                </Button>
            </Modal.Footer>
        </>
    );
};
